var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preview)?_c('div',[_c('label',{staticClass:"form-label"},[_vm._v("Preview")]),_c('PDFViewer',{staticStyle:{"height":"450px","width":"100%"},attrs:{"source":_vm.preview,"controls":['catalog', 'switchPage']}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }